import { render } from "./ProductEdit.vue?vue&type=template&id=2d6f9e35&scoped=true"
import script from "./ProductEdit.vue?vue&type=script&lang=js"
export * from "./ProductEdit.vue?vue&type=script&lang=js"

import "./ProductEdit.vue?vue&type=style&index=0&id=2d6f9e35&lang=scss&scoped=true"

import exportComponent from "C:\\inetpub\\wwwroot\\hesabtech-live\\hesabtech-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d6f9e35"]])

export default __exports__